<template>
  <section class="background-body">
    <v-container v-if="!isSuccess">
      <v-row class="fill-height mt-10" align-content="center" justify="center">
        <img
          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/sorry.png"
          class="img-fluid px-5"
          alt=""
          style="width: 350px"
        />
        <v-col class="headline text-center mt-10 deep-purple--text font-weight-bold" cols="12">
          Sedang proses sinkronisasi data ...
        </v-col>
        <v-col cols="6" md="6">
          <v-progress-linear color="deep-purple accent-4" indeterminate rounded height="6"> </v-progress-linear>
        </v-col>
      </v-row>
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center mt-10 " cols="12">
          Aplikasi sedang melakukan sinkronisasi data dari SIMPATIKA <br />
          Mohon ditunggu sampai prosesnya selesai dan kemudian aplikasi akan siap digunakan
        </v-col>
        <img
          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/logo-masook-fix.png"
          class="mt-10"
          alt=""
          style="width: 200px"
        />
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row class="fill-height mt-10" align-content="center" justify="center">
        <img
          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/berhasil.png"
          class="img-fluid px-5"
          alt=""
          style="width: 350px"
        />
        <v-col class="headline text-center mt-10 teal--text text--accent-4 font-weight-bold" cols="12">
          Sinkronisasi data sudah selesai
        </v-col>
        <v-col cols="6" md="6">
          <v-progress-linear color="teal accent-3" value="100" rounded height="6"> </v-progress-linear>
        </v-col>
      </v-row>
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center mt-10 " cols="12">
          Sinkronisasi data dari SIMPATIKA sudah selesai, klik tombol berikut untuk menuju aplikasi <br />
          <v-btn class="mt-5" color="teal accent-4" dark @click="toLogin">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
            </svg>
            &nbsp; Menuju Aplikasi
          </v-btn>
        </v-col>
        <img
          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/logo-masook-fix.png"
          class="mt-10"
          alt=""
          style="width: 200px"
        />
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      isSuccess: false,
      autoload: null,
      debounce: null,
    }
  },
  mounted() {
    this.checkQuery()
  },
  methods: {
    checkQuery() {
      if (this.$route.params.token) {
        this.$nextTick(() => {
          this.checkAktivasi()
        })
      }
    },

    checkAktivasi() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.$store
          .dispatch('user/getSinkronisasi', { token: this.$route.params.token })
          .then(({ data }) => {
            this.isSuccess = !!(data.status_organisasi === true && data.status_user)
          })
          .then(() => {
            if (this.isSuccess) {
              clearInterval(this.autoload)
            } else {
              this.setAutoSave()
            }
          })
      }, 5000)
    },

    setAutoSave() {
      this.autosave = setInterval(() => {
        this.checkAktivasi(true)
      }, 10000)
    },

    toLogin() {
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
<style scoped>
.background-body {
  background-image: url(https://cdn.siap.id/s3/masook/asset%20img/portal/bg-pelanggan.png);
  background-size: contain;
  background-color: white;
  height: 100%;
}

.container {
  max-width: 980px;
  /* max-width: 1020px; */
}
</style>
